module.exports = __webpack_public_path__ + "img/logo15.a30784a3.png";